import moment from 'moment'
export default {
  data () {
    return {
      currentUrl: '',
    }
  },
  created: function () {
  },
  mounted: function() {
     this.currentUrl = window.location.href;
    //  window.history.replaceState(null, "Đấu giá trực tuyến", "/"); 
  },
  filters: {
      formatDate: function (value) {
         if (!value) return ''
         return moment(String(value)).format('HH:mm:ss DD/MM/YYYY');
      }
   },
  methods: {
    reloadUrl(){
      window.location.href = this.currentUrl
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/mixin.js